import { clsx } from 'clsx';

import { useIntlLocale } from '@/hooks/useI18nLocale';

interface IDate {
  date?: Date;
  className?: string;
  size?: 'xs' | 's' | 'm';
}

export function DateText({ date, className, size = 's' }: IDate) {
  const locale = useIntlLocale();

  let options: Intl.DateTimeFormatOptions = {
    weekday: undefined,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  if (!date) {
    date = new Date();
  }

  if (size === 'm') {
    options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  } else if (size === 'xs') {
    const formatter = new Intl.DateTimeFormat(locale);
    return <span className={clsx('typo-body-semibold-paragraphLarge', className)}>{formatter.format(date)}</span>;
  }

  return (
    <span className={clsx(size === 's' ? 'typo-body-semibold-small' : 'typo-body-semibold-paragraphLarge', className)}>
      {date.toLocaleString(locale, options)}
    </span>
  );
}
